import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { VAM_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type { GitConnectionPostBody } from '@eggplant/types'

interface Props {
  params: GitConnectionPostBody
  onSuccess: (response: GitConnectionPostBody) => void
}

const CreateGitConnectionRequest = ({
  params,
  onSuccess
}: Props) => {
  const url = `${VAM_SERVICE}/repositories`

  const { requestParams } = useGetParamsWithSpaceId<GitConnectionPostBody>(params)

  return (
    <AuthenticatedDataRequest
      method='post'
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default CreateGitConnectionRequest
